document.addEventListener("DOMContentLoaded", function () {
  const checkInterval = setInterval(() => {
    const favoriteItem = document.getElementById("favoriteItem");
    if (favoriteItem && favoriteItem.textContent.trim()) {
      clearInterval(checkInterval);
      try {
        const data = JSON.parse(favoriteItem.textContent);
        if (data) {
          checkExistingWishlist(data);
        }
      } catch (e) {
        console.error("JSON parse error:", e);
      }
    }
  }, 300);

  setTimeout(() => clearInterval(checkInterval), 5000);

  ["click", "touchstart"].forEach((evtType) => {
    document.addEventListener(evtType, function (event) {
      const btn = event.target.closest(".modal-wishlist-btn");
      if (!btn) return;

      if (btn.classList.contains("processing")) return;
      btn.classList.add("processing");
      setTimeout(() => btn.classList.remove("processing"), 300);

      const activeProductId = btn.getAttribute("data-product-id");
      const activeVariantId = btn.getAttribute("data-variant-id");
      const wishlistItem = btn.closest(".wishlist-modal-wrapper");
      const accordion = wishlistItem.querySelector(".wishlist-modal-accordion");
      let imageSrc = wishlistItem.querySelector("img").getAttribute("src");
      imageSrc = imageSrc.replace("&width=100", "");
      const imageUrl = imageSrc.startsWith("http")
        ? imageSrc
        : "https:" + imageSrc;
      const productTitle = wishlistItem.querySelector(
        ".wishlist-product-title"
      ).value;
      const rawPrice = parseInt(
        wishlistItem.querySelector(".wishlist-variant-price").value,
        10
      );
      const productPrice = rawPrice / 100;
      const productUrl = window.location.origin + window.location.pathname;

      if (btn.classList.contains("added")) {
        deleteFromWishlist(activeProductId, activeVariantId, btn);
      } else {
        addToWishlist(
          activeProductId,
          activeVariantId,
          btn,
          imageUrl,
          productTitle,
          productPrice,
          productUrl
        );
        if (accordion) accordion.classList.add("open");
      }
    });
  });

  function checkExistingWishlist(favItems) {
    if (favItems) {
      // .wishlist-modal-item 要素をすべて取得
      document.querySelectorAll(".wishlist-modal-item").forEach((item) => {
        const button = item.querySelector(".modal-wishlist-btn");
        const productId = button.getAttribute("data-product-id");
        const variantId = button.getAttribute("data-variant-id");

        // favItems の sku_id と item_id と比較して、一致する場合は "added" クラスを付与
        const isInWishlist = favItems.some(
          (favItem) =>
            favItem.sku_id == variantId && favItem.item_id == productId
        );

        if (isInWishlist) {
          button.classList.add("added");
        }
      });
    }
  }
  function addToWishlist(
    productId,
    variantId,
    btn,
    imageUrl,
    productTitle,
    productPrice,
    productUrl
  ) {
    btn.classList.add("added");

    const favoriteItem = document.getElementById("favoriteItem");

    // 今回追加する商品データを定義
    const newItem = {
      item_id: productId,
      name: productTitle,
      price: productPrice,
      item_url: productUrl,
      item_image_url: imageUrl,
      sku_id: variantId,
      sku_url: productUrl + "?variant=" + variantId,
      sku_image_url: imageUrl,
    };

    if (!favoriteItem) {
      console.warn("favoriteItem element not found. Creating new one.");

      // KARTEへ送信（1件のみ）
      try {
        krt("send", "favorite", {
          added_item_id: productId,
          added_item_sku_id: variantId,
          quantity: 1,
          status: true,
          items: [newItem],
          is_added: true,
        });
      } catch (e) {
        console.error("KARTE send error:", e);
      }

      // <script>タグを新規作成してデータを入れる
      // const script = document.createElement("script");
      // script.type = "application/json";
      // script.id = "favoriteItem";
      // script.textContent = JSON.stringify([newItem]);
      // document.body.appendChild(script); // 任意の適切な場所へ追加（必要に応じて変更）

      return;
    }

    try {
      const parsedData = JSON.parse(favoriteItem.textContent);
      const itemsToAdd = Array.isArray(parsedData)
        ? parsedData.map((item) => ({
            item_id: item.item_id,
            name: item.name,
            price: item.price,
            item_url: item.item_url,
            item_image_url: item.item_image_url,
            sku_id: item.sku_id,
            sku_url: item.item_url + "?variant=" + item.sku_id,
            sku_image_url: item.sku_image_url,
          }))
        : [];

      // 重複チェック
      const isDuplicate = itemsToAdd.some(
        (item) => item.item_id == productId && item.sku_id == variantId
      );
      if (!isDuplicate) {
        itemsToAdd.push(newItem);

        // KARTEへ送信（既存分 + 今回分）
        try {
          krt("send", "favorite", {
            added_item_id: productId,
            added_item_sku_id: variantId,
            quantity: itemsToAdd.length,
            status: true,
            items: itemsToAdd,
            is_added: true,
          });
        } catch (e) {
          console.error("KARTE send error:", e);
        }

        // favoriteItemの中身を更新
        favoriteItem.textContent = JSON.stringify(itemsToAdd);
      }
    } catch (e) {
      console.error("favoriteItem JSON parse error:", e);
    }
  }
  function deleteFromWishlist(productId, variantId, btn) {
    btn.classList.remove("added");

    const favoriteItem = document.getElementById("favoriteItem");

    if (!favoriteItem) {
      // favoriteItemが存在しない場合でも、削除イベントだけは送る
      try {
        krt("send", "favorite", {
          deleted_item_id: productId,
          deleted_item_sku_id: variantId,
          quantity: 0,
          status: false,
          items: [],
          is_added: false,
        });
      } catch (e) {
        console.error("KARTE send error (no favoriteItem):", e);
      }
      return;
    }

    try {
      const parsedData = JSON.parse(favoriteItem.textContent);
      const itemsToSend = Array.isArray(parsedData)
        ? parsedData
            .filter(
              (item) => !(item.item_id == productId && item.sku_id == variantId)
            )
            .map((item) => ({
              item_id: item.item_id,
              name: item.name,
              price: item.price,
              item_url: item.item_url,
              item_image_url: item.item_image_url,
              sku_id: item.sku_id,
              sku_url: item.item_url + "?variant=" + item.sku_id,
              sku_image_url: item.sku_image_url,
            }))
        : [];

      try {
        krt("send", "favorite", {
          deleted_item_id: productId,
          deleted_item_sku_id: variantId,
          quantity: itemsToSend.length,
          status: itemsToSend.length > 0,
          items: itemsToSend,
          is_added: false,
        });
      } catch (e) {
        console.error("KARTE send error:", e);
      }

      // favoriteItemの中身を更新
      favoriteItem.textContent = JSON.stringify(itemsToSend);
    } catch (e) {
      console.error("favoriteItem JSON parse error (delete):", e);
    }
  }
});
